<template>
  <div class="flex items-center gap-6 grow justify-center relative -top-[10%]">
    <div
      v-for="(item, key) in options"
      :key="key"
      class="bg-white border shadow-black hover:shadow-xl cursor-pointer transition-shadow flex flex-col rounded-md"
      @click="setLayout(item.layout)"
    >
      <img :src="item.img" :alt="item.name" />
      <div class="flex flex-col p-4">
        <span class="text-xl font-bold">{{ item.name }}</span>
        <span class="text-sm text-gray-500">{{ item.description }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'vuex';
import INITIALLAYOUTS from '@/core/mode/layoutchooser/index';

export default {
  data() {
    const options = this.$app.props.options;
    const layouts = options.layouts;
    const finalLayouts = [];
    INITIALLAYOUTS.forEach(function (initiallayout) {
      let islayoutdisplay = false;
      layouts.forEach(function (layout) {
        layout = layout.trim();
        if (initiallayout.name === layout) {
          islayoutdisplay = true;
        }
      });
      if (islayoutdisplay) {
        finalLayouts.push(initiallayout);
      }
    });
    return {
      options: finalLayouts,
    };
  },
  methods: {
    ...mapActions('settings', ['changeLayout', 'setDrawingMode']),
    setLayout(layout) {
      this.changeLayout(layout);
      this.setDrawingMode();
    },
  },
};
</script>
